import React from 'react';
import logoLang from '@assets/Logo_mit_Name.svg';

const LogoLang = () => {
  return (
    <img src={logoLang} alt="svisit logo" className="h-8 w-auto mx-auto" />
  );
};

export default LogoLang;
